import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Icon from "./AppIcon";
import apiUtils from "utils/apiutils";
import Select from "./ui/Select";
import { Filter } from "lucide-react";

function TradeHistoryTable() {
  const [bots, setBots] = useState([]);


  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [togglefilter, settogglefilter] = useState(false)


  const [filters, setFilters] = useState({
    order: "",
    positionSide: "",
    tradeType: "",
    mode: "",
    botType: "",
    exchange: ""
  });

  const updateFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };



  const headers = [
    { key: "serial", label: "S.No" },
    { key: "Created_At", label: "DateTime" },
    { key: "Bot_ID", label: "Bot ID" },
    { key: "Order", label: "Order" },
    { key: "Exchange", label: "Exchange" },
    { key: "Bot Type", label: "Bot Type" },

    { key: "Position_Side", label: "Position Side" },
    { key: "Trade_Type", label: "Trade Type" },
    // { key: "Mode", label: "Mode" },
    { key: "Trade_Price", label: "Trade Price" },
    { key: "Position_Size", label: "Position Size" },
    // { key: "Exchange_Response", label: "Exchange Response" },
  ];

  const formatDate = (dateStr) => {
    try {
      return new Date(dateStr).toLocaleString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch {
      return "-";
    }
  };

  const formatMode = (mode) => {
    const styles = {
      PAPER: "bg-blue-500/20 text-blue-400",
      LIVE: "bg-green-500/20 text-green-400",
    };
    return (
      <span
        className={`px-2 py-0.5 rounded-full text-xs font-medium ${styles[mode] || "bg-muted text-foreground"
          }`}
      >
        {mode || "-"}
      </span>
    );
  };

  const formatAction = (action) => {
    const styles = {
      LONG_BUY: "bg-green-500/20 text-green-400",
      LONG_SELL: "bg-red-500/20 text-red-400",
      SHORT_BUY: "bg-orange-500/20 text-orange-400",
      SHORT_SELL: "bg-purple-500/20 text-purple-400",
    };
    return (
      <span
        className={`px-2 py-0.5 rounded-full text-xs font-medium ${styles[action] || "bg-muted text-foreground"
          }`}
      >
        {action || "-"}
      </span>
    );
  };

  const handleViewBots = async () => {
    setIsLoading(true);
    const payload = {
      page_no: pageNo,
      page_size: pageSize,

    };

    if (filters.tradeType) {
      payload.Trade_type = [filters.tradeType?.toUpperCase()];

    }
    if (filters.order) {
      payload.Order = [filters.order?.toUpperCase()];
    }

    if (filters.positionSide) {
      payload.Position_Side = [filters.positionSide?.toUpperCase()];
    }

    if (filters.mode) {
      payload.Mode = [filters.mode];

    }

    if (filters.exchange) {
      payload.Exchange = [filters.exchange?.toUpperCase()];
    }

    if (filters.botType) {
      payload.Bot_Type = [filters.botType];

    }

    try {
      const resp = await apiUtils.post("/bot/view_trade_history", payload, {
        showToast: false,
      });
      if (resp?.Success) {
        setBots(resp?.Success);
      }
    } catch (e) {
      console.error("Error fetching trade history:", e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewBotsTotal = async () => {
    setIsLoading(true);
    const payload = {
      page_no: pageNo,
      page_size: pageSize,

    };

    if (filters.tradeType) {
      payload.Trade_type = [filters.tradeType?.toUpperCase()];

    }
    if (filters.order) {
      payload.Order = [filters.order?.toUpperCase()];
    }

    if (filters.positionSide) {
      payload.Position_Side = [filters.positionSide?.toUpperCase()];
    }

    if (filters.mode) {
      payload.Mode = [filters.mode];

    }

    if (filters.exchange) {
      payload.Exchange = [filters.exchange?.toUpperCase()];
    }

    if (filters.botType) {
      payload.Bot_Type = [filters.botType];

    }

    if (filters.exchange) {
      payload.Exchange = [filters.exchange?.toUpperCase()];
    }
    try {
      const resp = await apiUtils.post(
        "/bot/total_view_trade_history",
        payload,
        {
          showToast: false,
        }
      );
      if (resp?.Success) {
        setTotalPages(resp.Success);
      }
    } catch (e) {
      console.error("Error fetching total pages:", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleViewBots();
    handleViewBotsTotal();
  }, [pageNo, pageSize]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Icon name="Loader" size={28} className="animate-spin text-ring" />
      </div>
    );
  }



  const handlePrevPage = () => {
    if (pageNo > 1) setPageNo(pageNo - 1);
  };

  const handleNextPage = () => {
    if (pageNo < totalPages) setPageNo(pageNo + 1);
  };



  return (
    <>
      {/* Desktop Table */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="bg-card border border-border rounded-xl mb-6 overflow-hidden"
      >

        <h2 className="text-xl font-bold m-4">Trade History</h2>
        {/* Filters */}
        <div className="p-4 bg-card/30 rounded-xl border border-border mb-4">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-semibold mb-3 flex items-center gap-2">
              Filters
            </h3>

            <div className=" top-6 right-6 cursor-pointer" onClick={() => settogglefilter(!togglefilter)}>
              <Filter />
            </div>
          </div>

          {togglefilter && <>  <div className="grid grid-cols-1 md:grid-cols-5 gap-4">

            {/* Order */}
            <div>
              <Select
                label="Order"
                tooltip="Filter trades by order type"
                options={[
                  { label: "All", value: "" },
                  { label: "Buy", value: "Buy" },
                  { label: "Sell", value: "Sell" }
                ]}
                value={filters.order}
                onChange={(v) => updateFilter("order", v)}
                className="my-4"
              />
            </div>

            {/* Position Side */}
            <div>
              <Select
                label="Position Side"
                tooltip="Filter trades by position side"
                options={[
                  { label: "All", value: "" },
                  { label: "Long", value: "Long" },
                  { label: "Short", value: "Short" }
                ]}
                value={filters.positionSide}
                onChange={(v) => updateFilter("positionSide", v)}
                className="my-4"
              />
            </div>

            {/* Trade Type */}
            <div>
              <Select
                label="Trade Type"
                tooltip="Filter trades by trade type"
                options={[
                  { label: "All", value: "" },
                  { label: "Live", value: "Live" },
                  { label: "Paper", value: "Paper" }
                ]}
                value={filters.tradeType}
                onChange={(v) => updateFilter("tradeType", v)}
                className="my-4"
              />
            </div>


            {/* Mode */}
            {/* <div>
  <Select
    label="Mode"
    tooltip="Filter trades by trading mode"
    options={[
      { label: "All", value: "" },
      { label: "Long Only", value: "LONG_ONLY" },
      { label: "Hedge", value: "HEDGE" },
      { label: "Short Only", value: "SHORT_ONLY" },
      { label: "Long", value: "LONG" },
      { label: "Short", value: "SHORT" }
    ]}
    value={filters.mode}
    onChange={(v) => updateFilter("mode", v)}
    className="my-4"
  />
</div> */}


            <div>
              <Select
                label="Bot Type"
                tooltip="Filter trades by bot type"
                options={[

                  { label: "LIQUIDATION", value: "LIQUIDATION" },
                  { label: "TP_SL", value: "TP_SL" },


                ]}
                value={filters.botType}
                onChange={(v) => updateFilter("botType", v)}
                className="my-4"
              />
            </div>


            <div>
              <Select
                label="Exchange"
                tooltip="Filter trades by exchange"
                options={[

                  { label: "BINANCE", value: "BINANCE" },
                  { label: "BYBIT", value: "BYBIT" },


                ]}
                value={filters.exchange}
                onChange={(v) => updateFilter("exchange", v)}
                className="my-4"
              />
            </div>


          </div>

            {/* Apply Button */}
            <div className="flex justify-end mt-4">
              <button
                onClick={() => {
                  handleViewBots();
                  handleViewBotsTotal();
                }}
                className="px-4 py-2 bg-primary text-secondary rounded-lg hover:bg-primary/80"
              >
                Apply Filters
              </button>
            </div></>}


        </div>

        {/* if (!Array.isArray(bots) || bots.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <Icon name="Inbox" size={48} className="mx-auto mb-4 opacity-30" />
        <p className="text-lg">No trade history found.</p>
      </div>
    );
  } */}

        {!Array.isArray(bots) || bots.length === 0 ?
          <><div className="text-center py-12 text-muted-foreground">
            <Icon name="Inbox" size={48} className="mx-auto mb-4 opacity-30" />
            <p className="text-lg">No trade history found.</p>
          </div></> : <> <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-left">
              <thead className="text-sm uppercase bg-card/50 border-b border-border">
                <tr>
                  {headers.map((h) => (
                    <th
                      key={h.key}
                      className="px-3 py-3 font-medium text-foreground/70 whitespace-nowrap"
                    >
                      {h.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {bots?.map((bot, index) => (
                  <motion.tr
                    key={bot.Bot_ID + index} // Use index to ensure unique key
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.25, delay: index * 0.03 }}
                    className="border-b border-border hover:bg-primary/5 transition text-xs"
                  >
                    <td className="px-3 py-3 font-medium text-foreground/80">
                      {(pageNo - 1) * pageSize + index + 1}
                    </td>
                    <td className="px-3 py-3 text-muted-foreground">
                      {formatDate(bot.Created_At)}
                    </td>
                    <td className="px-3 py-3 font-medium">{bot.Bot_ID || "-"}</td>
                    <td className="px-3 py-3">{formatAction(bot.Order)}</td>
                    <td className="px-3 py-3">{formatAction(bot.Exchange)}</td>
                    <td className="px-3 py-3">{formatAction(bot.Bot_Type)}</td>

                    <td className="px-3 py-3">{formatAction(bot.Position_Side)}</td>
                    <td className="px-3 py-3">{formatAction(bot.Trade_Type)}</td>

                    {/* <td className="px-3 py-3">{formatMode(bot.Mode)}</td> */}
                    <td className="px-3 py-3">{bot.Trade_Price?.toFixed(3) ?? "-"}</td>
                    <td className="px-3 py-3">
                      {bot.Position_Size?.toFixed(2) ?? "-"}
                    </td>
                    {/* <td className="px-3 py-3">{bot.Exchange_Response ?? "-"}</td> */}
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </div>

            {/* Mobile Cards */}
            <div className="md:hidden p-4 space-y-4">
              {bots?.map((bot, index) => (
                <motion.div
                  key={bot.Bot_ID + index} // Use index to ensure unique key
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.25, delay: index * 0.05 }}
                  className="bg-card/50 border border-border rounded-xl p-4 shadow-sm"
                >
                  <div className="text-xs text-muted-foreground mb-3">
                    Trade #{(pageNo - 1) * pageSize + index + 1} •{" "}
                    {formatDate(bot.Created_At)}
                  </div>
                  <div className="grid grid-cols-2 gap-3 text-xs">
                    <div>
                      <span className="text-foreground/70">Bot ID</span>
                      <p className="font-medium truncate">{bot.Bot_ID || "-"}</p>
                    </div>
                    <div>
                      <span className="text-foreground/70">Order</span>
                      <p>{formatAction(bot.Order)}</p>
                    </div>

                    <div>
                      <span className="text-foreground/70">Exchange</span>
                      <p>{formatAction(bot.Exchange)}</p>
                    </div>

                    <div>
                      <span className="text-foreground/70">Bot Type</span>
                      <p>{formatAction(bot.Bot_Type)}</p>
                    </div>
                    <div>
                      <span className="text-foreground/70">Position Side</span>
                      <p>{formatAction(bot.Position_Side)}</p>
                    </div>
                    <div>
                      <span className="text-foreground/70">Trade Type</span>
                      <p>{formatAction(bot.Trade_Type)}</p>
                    </div>
                    {/* <div>
                  <span className="text-foreground/70">Mode</span>
                  <p>{formatMode(bot.Mode)}</p>
                </div> */}
                    <div>
                      <span className="text-foreground/70">Trade Price</span>
                      <p>{bot.Trade_Price?.toFixed(3) ?? "-"}</p>
                    </div>
                    <div>
                      <span className="text-foreground/70">Position Size</span>
                      <p>{bot.Position_Size?.toFixed(2) ?? "-"}</p>
                    </div>
                    {/* <div className="col-span-2">
                  <span className="text-foreground/70">Exchange Response</span>
                  <p>{bot.Exchange_Response ?? "-"}</p>
                </div> */}
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="flex items-center justify-between px-6 py-4 border-t border-primary bg-card/50">
              <button
                onClick={handlePrevPage}
                disabled={pageNo === 1}
                className="px-5 py-2 rounded-lg bg-primary/10 hover:bg-primary/20 disabled:opacity-50 disabled:cursor-not-allowed transition text-sm font-medium"
              >
                Previous
              </button>

              <span className="text-sm font-medium">
                Page <span className="text-primary">{pageNo}</span> / {totalPages}
              </span>

              <button
                onClick={handleNextPage}
                disabled={pageNo === totalPages}
                className="px-5 py-2 rounded-lg bg-primary/10 hover:bg-primary/20 disabled:opacity-50 disabled:cursor-not-allowed transition text-sm font-medium"
              >
                Next
              </button>
            </div></>
        }




      </motion.div>
    </>
  );
}

export default TradeHistoryTable;
